module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyAQMAAACQ++z9AAAABlBMVEWeMDn///+ut+dDAAAAFklEQVR4AWPADkbBfyTwYYB5WMEoAABNwIDpVKi0GwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/lv.png
// module id = ztu8
// module chunks = 0